<div class="testimonials-section">
<h3>{{heading}}</h3>
<div *ngIf="subheading" class="subtext">{{subheading}}</div>
  <div class="container flex-ele">
    <ngx-glide [showArrows]="false" [gap]="20" [showBullets]="true" [perView]="3" [bound]="true" [dragThreshold]="false" [breakpoints]="breakpoints">
      <div *ngFor="let card of cards" class="t-card">
        <div class="text">
          {{card.content}}
          <div class="d-name">
            {{card.donor}}
            <div><span>Monthly Contributor</span><img *ngIf="card.image" loading="lazy" [attr.data-src]="card.image" alt=""/></div>
          </div>
        </div>
      </div>
    </ngx-glide>
  </div>
</div>
